export const controlConstants = {
  CHARGING_NETWORK_OPERATOR: "CHARGING_NETWORK_OPERATOR",
  RETAIL: "RETAIL",
  K1: "K1",
  K2: "K2",
  AGGREGATOR: "AGGREGATOR",
  PASSIVE: "PASSIVE",
  PARTIAL_PASSIVE: "PARTIAL_PASSIVE",
  PRODUCTION: "PRODUCTION",
  ACTIVE: "ACTIVE",
};
